import React, { Component } from 'react';
import {connect } from 'react-redux'
import PropTypes from 'prop-types'
import { 
    withStyles,
    FormControl,
    FormLabel,
    Typography,
    Button
} from '@material-ui/core';
import GridContainer from '../../components/Grid/GridContainer'
import GridItem from '../../components/Grid/GridItem'
import requisitionStyle from '../../assets/jss/requisitionStyle'
import '../../assets/css/requisition.css'
import { 
    withCookies,
} from 'react-cookie'
import {
    getRequisitionDetail
} from '../../actions/RequisitionActions'
import {
    Redirect
} from 'react-router-dom'
import {
    
} from '../../utils/routes'
import moment from 'moment'
import { Markup } from "interweave";
import {
    NavLink,
} from 'react-router-dom'
import {
    ROUTE_REQUISITION_LIST,
    ROUTE_ADMIN_CV,
    ROUTE_ADMIN_JOB,
    ROUTE_ADMIN_LOGIN,
    ROUTE_REQUISITION_DETAIL
} from '../../utils/routes'
import InformationDialog from '../../components/Dialog/InformationDialog'
import {
    logout
} from '../../actions/LoginAction'

class RequisitionDetail extends Component {

    constructor() {
        super();
        this.state = {
          open: false,
        }
    }

    componentWillMount() {
        const {match: {params}} = this.props
        const id = params.id;
        this.props.getRequisitionDetail({id, jwt: this.props.cookies.cookies.jwt})
    }

    render() {

        const {classes, requisition_item} = this.props
        
        if(requisition_item.unauthorize){
            return(
                <Redirect from={ROUTE_REQUISITION_DETAIL} to={ROUTE_ADMIN_LOGIN}/>
            )
        }
       
        if(this.props.requisition_item.item !== null) {

            const {
                // additional_information, 
                hiring_manager_email,
                department_head_email,
                interviewers,
                number_of_positions,
                position_information,
                replacement,
                sourcing,
                status,
                // submitted_by,
                type,
                target_date
            } = requisition_item.item

            return(
                <div>
                    <div className={classes.main}>
                        <div className="Content">

                            <InformationDialog
                                open={this.state.open}
                                handleClose={this.handleClose}
                                handleLogout={this.handleLogout}
                            />

                            <div className="CvBtn">

                                <NavLink from={ROUTE_REQUISITION_LIST} to={ROUTE_REQUISITION_LIST}>
                                    <Button variant="outlined" className={classes.nav_button} color="secondary">
                                        View Requisitions
                                    </Button>
                                </NavLink>

                                <NavLink  from={ROUTE_REQUISITION_LIST} to={ROUTE_ADMIN_JOB}>
                                    <Button variant="outlined" className={classes.nav_button}  color="secondary">
                                        View Jobs
                                    </Button>
                                </NavLink>

                                <NavLink from={ROUTE_REQUISITION_LIST} to={ROUTE_ADMIN_CV}>
                                    <Button variant="outlined" className={classes.nav_button} color="secondary">
                                        View CVs
                                    </Button>
                                </NavLink>
                                <Button 
                                    onClick={() => this.onLogout()}
                                    variant="outlined" 
                                    className={classes.nav_button} 
                                    color="secondary">
                                    Logout
                                </Button>

                            </div>
    
                            {
                                requisition_item.item === null ? (
                                    <div>
                                        Loading ...
                                    </div>
                                ):(
                                    <div>
                                        
                                        <h4 className="Employee-Requisition-Form">
                                            Position Information
                                        </h4>
                                        <GridContainer>
                                        
                                            <GridItem  xs={12} sm={12} md={6}>
                                                <FormControl className={classes.item} component="fieldset">
                                                    <FormLabel>
                                                        Title
                                                    </FormLabel>
                                                    <Typography className={classes.itemValue} variant="h6" gutterBottom>
                                                        { position_information.title }
                                                    </Typography>
                                                    
                                                </FormControl>
                                            </GridItem>
                                            <GridItem  xs={12} sm={12} md={6}>
                                                <FormControl className={classes.item} component="fieldset">
                                                    <FormLabel>
                                                        Designation
                                                    </FormLabel>
                                                    <Typography className={classes.itemValue} variant="h6" gutterBottom>
                                                        { position_information.designation }
                                                    </Typography>
                                                    
                                                </FormControl>
                                            </GridItem>

                                            <GridItem  xs={12} sm={12} md={6}>
                                                <FormControl className={classes.item} component="fieldset">
                                                    <FormLabel>
                                                        Type
                                                    </FormLabel>
                                                    <Typography className={classes.itemValue} variant="h6" gutterBottom>
                                                        { type }
                                                    </Typography>

                                                    {
                                                        type !== 'new' && (
                                                            <Typography className={classes.itemValue} variant="subtitle1" gutterBottom>
                                                                Employee name: { 
                                                                    replacement.employee_name
                                                                }
                                                            </Typography>
                                                        )
                                                    }
                                                    
                                                </FormControl>
                                            </GridItem>

                                            <GridItem  xs={12} sm={12} md={6}>
                                                <FormControl className={classes.item} component="fieldset">
                                                    <FormLabel>
                                                        Number of positions
                                                    </FormLabel>
                                                    <Typography className={classes.itemValue} variant="h6" gutterBottom>
                                                        { number_of_positions }
                                                    </Typography>
                                                    
                                                </FormControl>
                                            </GridItem>

                                            <GridItem  xs={12} sm={12} md={6}>
                                                <FormControl className={classes.item} component="fieldset">
                                                    <FormLabel>
                                                        Hiring manager email
                                                    </FormLabel>
                                                    <Typography className={classes.itemValue} variant="h6" gutterBottom>
                                                        { hiring_manager_email }
                                                    </Typography>
                                                    
                                                </FormControl>
                                            </GridItem>

                                            <GridItem  xs={12} sm={12} md={6}>
                                                <FormControl className={classes.item} component="fieldset">
                                                    <FormLabel>
                                                        Department head email
                                                    </FormLabel>
                                                    <Typography className={classes.itemValue} variant="h6" gutterBottom>
                                                        { department_head_email }
                                                    </Typography>
                                                    
                                                </FormControl>
                                            </GridItem>
    
                                            <GridItem xs={12} sm={12} md={6}>
    
                                                <FormControl className={classes.item} component="fieldset">
                                                    <FormLabel>
                                                        Department
                                                    </FormLabel>
                                                    <Typography className={classes.itemValue} variant="h6" gutterBottom>
                                                        { position_information.department }
                                                    </Typography>
                                                    
                                                </FormControl>
    
                                            </GridItem>
                                            <GridItem xs={12} sm={12} md={6}>
                                                <FormControl className={classes.item} component="fieldset">
                                                    <FormLabel>
                                                        Entity
                                                    </FormLabel>
                                                    <Typography className={classes.itemValue} variant="h6" gutterBottom>
                                                        { position_information.entity }
                                                    </Typography>
                                                    
                                                </FormControl>
                                            </GridItem>
    
                                            <GridItem xs={12} sm={12} md={6}>
    
                                                <FormControl className={classes.item} component="fieldset">
                                                    <FormLabel>
                                                        Location
                                                    </FormLabel>
                                                    <Typography className={classes.itemValue} variant="h6" gutterBottom>
                                                        { position_information.location }
                                                    </Typography>
                                                    
                                                </FormControl>
    
                                            </GridItem>
                                            <GridItem xs={12} sm={12} md={6}>
                                                <FormControl className={classes.item} component="fieldset">
                                                    <FormLabel>
                                                        Contract
                                                    </FormLabel>
                                                    <Typography className={classes.itemValue} variant="h6" gutterBottom>
                                                        { position_information.contract.type }
                                                    </Typography>
                                                    {
                                                        position_information.contract.from !== position_information.contract.to && (
                                                            <Typography className={classes.itemValue} variant="subtitle1" gutterBottom>
                                                                From: { this.convertdate(position_information.contract.from) } - To: {this.convertdate(position_information.contract.to)}
                                                            </Typography>
                                                        )
                                                    }
                                                    
                                                </FormControl>
                                            </GridItem>
    
                                            <GridItem xs={12} sm={12} md={6}>
                                                <FormControl className={classes.item} component="fieldset">
                                                    <FormLabel>
                                                        Minimum Salary
                                                    </FormLabel>
                                                    <Typography className={classes.itemValue} variant="h6" gutterBottom>
                                                        { position_information.salary.min.amount}
                                                    </Typography>
                                                    
                                                </FormControl>
                                            </GridItem>
                                            
    
                                            
                                            <GridItem xs={12} sm={12} md={6}>
    
                                                <FormControl className={classes.item} component="fieldset">
                                                    <FormLabel>
                                                        Category
                                                    </FormLabel>
    
                                                    <Typography className={classes.itemValue} variant="h6" gutterBottom>
                                                        {
                                                            position_information.category.map((item, key) => 
                                                                <div key={key}>
                                                                    {
                                                                        item
                                                                    }
                                                                </div>
                                                            )
                                                        }
                                                    </Typography>
                                                    
                                                </FormControl>
    
                                            </GridItem>

                                            <GridItem xs={12} sm={12} md={6}>
    
                                                <FormControl className={classes.item} component="fieldset">
                                                    <FormLabel>
                                                        Maximum Salary
                                                    </FormLabel>
                                                    <Typography className={classes.itemValue} variant="h6" gutterBottom>
                                                         { position_information.salary.max.amount}
                                                    </Typography>
                                                    
                                                </FormControl>
    
                                            </GridItem>

                                            <GridItem xs={12} sm={12} md={6}>
    
                                                <FormControl className={classes.item} component="fieldset">
                                                    <FormLabel>
                                                        Target Date
                                                    </FormLabel>
                                                    <Typography className={classes.itemValue} variant="h6" gutterBottom>
                                                         {this.convertdate(target_date)}
                                                    </Typography>
                                                    
                                                </FormControl>
    
                                            </GridItem>
    
                                            <GridItem xs={12} sm={12} md={12}>
    
                                                <FormControl className={classes.item} component="fieldset">
                                                    <FormLabel>
                                                        Requirment
                                                    </FormLabel>
                                                    
                                                    {/* <Typography className={classes.itemValue} variant="h6" gutterBottom> */}
                                                        <Markup content={position_information.requirements}/>
                                                        {/* {position_information.requirements} */}
                                                    {/* </Typography> */}
                                                    
                                                </FormControl>
    
                                            </GridItem>

                                            <GridItem xs={12} sm={12} md={12}>
    
                                                <FormControl className={classes.item} component="fieldset">
                                                    <FormLabel>
                                                        Description
                                                    </FormLabel>
                                                    
                                                    {/* <Typography className={classes.itemValue} variant="h6" gutterBottom> */}
                                                        <Markup content={position_information.description}/>
                                                        {/* {position_information.description} */}
                                                    {/* </Typography> */}
                                                    
                                                </FormControl>
    
                                            </GridItem>
    
                                        </GridContainer>
    
                                        <h4 className="Employee-Requisition-Form">
                                            Sourcing and Selection
                                        </h4>
                                        <GridContainer>
                                            <GridItem  xs={12} sm={12} md={6}>
                                                <FormControl className={classes.item} component="fieldset">
                                                    <FormLabel>
                                                        Advertisting Channels
                                                    </FormLabel>
                                                    {
                                                        sourcing.advertising.channels.map((channel, key) => 
                                                            <Typography 
                                                                className={classes.itemValue} 
                                                                variant="h6" 
                                                                gutterBottom
                                                                key={key}>
                                                                {
                                                                    channel
                                                                }
                                                            </Typography>
                                                        )
                                                    }
                                                    
                                                </FormControl>
                                            </GridItem>
    
                                            <GridItem  xs={12} sm={12} md={6}>
                                                <FormControl className={classes.item} component="fieldset">
                                                    <FormLabel>
                                                        International?
                                                    </FormLabel>
                                                    <Typography className={classes.itemValue} variant="h6" gutterBottom>
                                                        {
                                                            sourcing.advertising.international ? <div>Yes</div>: <div>No</div>
                                                        }
                                                    </Typography>
                                                    
                                                </FormControl>
                                            </GridItem>
                                            <GridItem  xs={12} sm={12} md={6}>
                                                <FormControl className={classes.item} component="fieldset">
                                                    <FormLabel>
                                                        Lengths
                                                    </FormLabel>
                                                    <Typography className={classes.itemValue} variant="h6" gutterBottom>
                                                        {
                                                            sourcing.advertising.length
                                                        } Weeks
                                                    </Typography>
                                                    
                                                </FormControl>
                                            </GridItem>
    
                                            <GridItem  xs={12} sm={12} md={6}>
                                                <FormControl className={classes.item} component="fieldset">
                                                    <FormLabel>
                                                        Process
                                                    </FormLabel>
                                                    <Typography className={classes.itemValue} variant="h6" gutterBottom>
                                                        {
                                                            sourcing.advertising.process
                                                        }
                                                    </Typography>
                                                    
                                                </FormControl>
                                            </GridItem>
                                            <GridItem  xs={12} sm={12} md={6}>
                                                <FormControl className={classes.item} component="fieldset">
                                                    <FormLabel>
                                                    All applications or shortlist only?
                                                    </FormLabel>
                                                    <Typography className={classes.itemValue} variant="h6" gutterBottom>
                                                        {
                                                            sourcing.advertising.source
                                                        }
                                                    </Typography>
                                                    
                                                </FormControl>
                                            </GridItem>
    
                                            <GridItem  xs={12} sm={12} md={6}>
                                                <FormControl className={classes.item} component="fieldset">
                                                    <FormLabel>
                                                        Status
                                                    </FormLabel>
                                                    <Typography className={classes.itemValue} variant="h6" gutterBottom>
                                                        {
                                                            status
                                                        }
                                                    </Typography>
                                                    
                                                </FormControl>
                                            </GridItem>

                                            {/* <GridItem  xs={12} sm={12} md={6}>
                                                <FormControl className={classes.item} component="fieldset">
                                                    <FormLabel>
                                                        comments
                                                    </FormLabel>
                                                    <Typography className={classes.itemValue} variant="h6" gutterBottom>
                                                        
                                                    </Typography>
                                                    
                                                </FormControl>
                                            </GridItem> */}
    
                                        </GridContainer>
    
                                        <h4 className="Employee-Requisition-Form">
                                            Interviewers
                                        </h4>
                                        <GridContainer>
                                            
                                            <GridItem  xs={12} sm={12} md={6}>

                                                <FormControl className={classes.item} component="fieldset">
                                                    {
                                                    interviewers.map((interviewer, key) => 
                                                        <Typography className={classes.itemValue} variant="h6" gutterBottom key={key}>
                                                            {
                                                                interviewer
                                                            }
                                                        </Typography>
                                                        )
                                                    }
                                                   
                                                </FormControl>
                                            </GridItem>
                                        </GridContainer>
    
                                    </div>
                                )
                            }
    
                            
                        </div>
                    </div>
                </div>
                
            )


        }else{
           return <div>Loading...</div>
        }
        
    }

    convertdate = (date) => {
        var d = new Date(date);
        return moment(d.toLocaleString()).format('MMMM Do YYYY');
    }

    onLogout = () => {
        this.setState({
            open: true
        })
    }

    handleClose = () => {
        this.setState({
            open: false
        })
    }

    handleLogout = () => {
        this.setState({
            open: false
        })
        this.props.logout()
        this.props.history.replace(ROUTE_ADMIN_LOGIN, { firstPage: true});
      //  this.props.history.push(ROUTE_ADMIN_LOGIN);

    }


}

RequisitionDetail.propTypes = {
    classes: PropTypes.object.isRequired
}

const mapDispatchToProps = (dispatch,) => ({
    getRequisitionDetail: (prop) => {
        dispatch(
            getRequisitionDetail(prop)
        )
    },
    logout: () => {
        dispatch(
            logout()
        )
    } 
  })
  
const mapStateToProps = (state, ownProps) => ({
    requisition_item: state.requisition,
    ownProps: ownProps.cookies
})

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(requisitionStyle)(withCookies(RequisitionDetail)))